import SpriteSymbol from "../../../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chat-1-fill",
  "use": "icon-chat-1-fill-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-chat-1-fill\">\n    <g>\n        <path fill=\"none\" d=\"M0 0h24v24H0z\" />\n        <path d=\"M10 3h4a8 8 0 1 1 0 16v3.5c-5-2-12-5-12-11.5a8 8 0 0 1 8-8z\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol